import {useContext} from 'react';
import {InformerConfigContext} from './InformerConfigProvider';

export function useInformerConfigState() {
	return useContext(InformerConfigContext)!;
}

useInformerConfigState.displayName = 'useInformerConfigState';
